import {GenexLMSModel} from "@/models/lms/GenexLMSModel";
import Module from "@/models/lms/Module";
import Question from "@/models/lms/Question";
import GenexHelperMixins from "@/mixins/GenexHelperMixins";

export default class Quiz extends GenexLMSModel {
    static entity = 'quizzes'
    // get is_timed() {
    //         return 1
    // }
    // get time() {
    //     return '09:09'
    // }
    static fields() {

        return {
            type: this.attr('quizzes'),
            id: this.attr(null),
            order: this.attr(null),
            module_id: this.attr(null),
            module: this.belongsTo(Module, 'module_id'),
            name: this.attr(null),
            questions: this.hasMany(Question, 'quiz_id'),
            is_required_for_pass: this.attr(0),
            is_auto_graded: this.attr(0),
            needed_to_pass: this.attr(0),
            result: this.attr(null),
            has_negative_marking: this.attr(0),
            randomize_question_order: this.attr(0),
            is_timed: this.attr(0),
            time: this.attr(null),
            completed: this.attr(false),
            completed_at: this.attr(null),
        }
    }

    /**
     * Completes a quiz
     * @function
     * @param {number} quiz_id -
     * @param {Object} response
     * @param {number} response.module_id
     * @param {number} response.course_id
     * @param {Array} response.answers
     * @returns {Promise<Response>}
     */

    static Submit(quiz_id, response) {
        return this.api().post(`quizzes/${quiz_id}/responses`, response, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
                dataTransformer: ({data: {data}}) => {
                },
            }
        )
    }

    /**
     * Completes a lesson
     * @function
     * @param {number} quiz_id -
     * @param {Object} body
     * @param {number} body.module_id
     * @param {number} body.course_id
     * @returns {Promise<Response>}
     */

    static Retake(quiz_id, body) {
        return this.api().post(`quizzes/${quiz_id}/retake`, body, {
            ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
            }
        )
    }

    /**
     * Returns a quiz
     * @function
     * @param {number} quiz_id - The lesson_id
     * @param {?Object} [query={}] - Query terms for the request
     * @param {Number} [query.module_id] - Query terms for the request
     * @param {Array.<string>} [relationships=[]] - Relationships to bring along
     * @returns {Promise<Response>}
     */

    static FetchById(quiz_id, relationships = [], query = {}) {
        return this.api().get(`/quizzes/${quiz_id}`, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
            params: {
                ...{
                    with: relationships
                }, ...(query !== {} ? query : {}),
            },
                persistOptions: {
                    create: ['questions']
                },
                dataTransformer: ({data: {data}}) => {
                    if (relationships.includes('questions')) {
                        if (Object.prototype.hasOwnProperty.call(data.attributes, 'questions')) {
                            data.attributes.questions.map(question => {
                                if (Object.prototype.hasOwnProperty.call(question.attributes, 'answers')) {
                                    question.attributes.answers.map(answer => {
                                        Object.assign(answer, answer.attributes)
                                    })
                                }
                                Object.assign(question, question.attributes)

                            })

                        }
                    }
                    return {...data, ...data.attributes}
                },
            }
        )
    }

}
